/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable producers
import { tableSchemaBase as columns } from '../producers.columns';
import { tableSchemaBase as columnsForPartner } from '../producersForPartner.columns';
import { tableSchemaBase as columnsWithoutContact } from '../producersWithoutContact.columns';
import { tableSchemaBase as columnsWithoutOrganization } from '../producersWithoutOrganization.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IProducersDatatableSlice {
	producersDatatableOptions: TColumnsSchema[];
	setProducersDatatableOptions: (
		_producersDatatableOptions: TColumnsSchema[]
	) => void;

	producersWithoutContactDatatableOptions: TColumnsSchema[];
	setProducersWithoutContactDatatableOptions: (
		_producersDatatableOptions: TColumnsSchema[]
	) => void;

	producersWithoutOrganizationDatatableOptions: TColumnsSchema[];
	setProducersWithoutOrganizationDatatableOptions: (
		_producersDatatableOptions: TColumnsSchema[]
	) => void;

	producersForPartnerDatatableOptions: TColumnsSchema[];
	setProducersForPartnerDatatableOptions: (
		_producersDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeProducersDatatableSlice = (
	s: any
): any => ({
	producersDatatableOptions: s.producersDatatableOptions,
	producersWithoutContactDatatableOptions:
		s.producersWithoutContactDatatableOptions,
	producersWithoutOrganizationDatatableOptions:
		s.producersWithoutOrganizationDatatableOptions,
	producersForPartnerDatatableOptions:
		s.producersForPartnerDatatableOptions,
	producersForProducerDatatableOptions:
		s.producersForProducerDatatableOptions,
});

const initialState = {
	producersDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
	producersWithoutContactDatatableOptions:
		columnsWithoutContact.filter(
			(item) => item.defaultVisible
		),
	producersWithoutOrganizationDatatableOptions:
		columnsWithoutOrganization.filter(
			(item) => item.defaultVisible
		),
	producersForPartnerDatatableOptions:
		columnsForPartner.filter(
			(item) => item.defaultVisible
		),
};

export const createProducersDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', unknown]],
	[],
	IProducersDatatableSlice
> = (set) => ({
	...initialState,

	setProducersDatatableOptions: (
		options: TColumnsSchema[]
	) => set({ producersDatatableOptions: options }),

	setProducersWithoutContactDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({
			producersWithoutContactDatatableOptions: options,
		}),

	setProducersWithoutOrganizationDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({
			producersWithoutOrganizationDatatableOptions:
				options,
		}),

	setProducersForPartnerDatatableOptions: (
		options: TColumnsSchema[]
	) =>
		set({
			producersForPartnerDatatableOptions: options,
		}),
});
